import { Pipe, PipeTransform } from '@angular/core';
import { resolveFieldData } from 'src/formio-custom-components/src/lib/shared/utility';

@Pipe({
	name: 'getValue',
})
export class GetValuePipe implements PipeTransform {
	transform(option: any, optionValue: any, _default: string = 'value'): any {
		return getOptionValue(option, optionValue, _default);
	}
}

export function getOptionValue(
	option: any,
	optionValue: any,
	_default: string = 'value'
) {
	const result = optionValue
		? resolveFieldData(option, optionValue)
		: option && option?.[_default] !== undefined
		? option?.[_default]
		: null;
	return result;
}
